import { MediaMatcher } from '@angular/cdk/layout';
import { ChangeDetectorRef, Component } from '@angular/core';
import { MapHelperService } from 'src/services/map-helper.service';
import { NotificationsToastService } from 'src/app/features/shared/services/Notifications-Toast.service';
import { environment } from "src/environments/environment";
import { PolygonDrawToolService } from 'src/services/maps/features/PolygonDrawTool.service';
import { PanelAddGeofencesService } from '../../../../services/Panel-Add-Geofences.service';

@Component({
  selector: 'geofence-polygon-creator',
  templateUrl: './geofence-polygon-creator.component.html',
  styleUrls: ['./geofence-polygon-creator.component.css']
})
export class GeofencePolygonCreatorComponent {
  mobileQuery: MediaQueryList;
    private _mobileQueryListener: () => void;
    fullScreen: boolean = false;

    public $guidEditable: string = "";
    public $isDuplicate: boolean = false;
  
    polygonButtonMsg: string = "Selecciona varios puntos en el mapa para crear una figura y para finalizar da doble click sobre el mapa";
    isPolygonButtonMsgVisible : boolean = false;
    polygonFinishMsg: string = "Hacer doble clic para finalizar colocación de vertices y mover la figura.";
    polygonEditButtonMsg: string = "Seleccione el poligono para editarlo. Puede mover la figura o agregar más puntos";
    isPolygonEditButtonMsgVisible : boolean = false;
  
    
    AddPolygonSelected: string = "";
  
    constructor(changeDetectorRef: ChangeDetectorRef, 
      media: MediaMatcher,
      private mapHelperService: MapHelperService,
      private panelAddGeofencesService: PanelAddGeofencesService,
      private notificationToastService: NotificationsToastService,
      private polygonDrawToolService: PolygonDrawToolService) {
      this.mobileQuery = media.matchMedia("(min-width: 769px)");
      this._mobileQueryListener = () => changeDetectorRef.detectChanges();
      this.mobileQuery.addListener(this._mobileQueryListener);

      
      this.$guidEditable = this.panelAddGeofencesService.$guidEditable;
      this.$isDuplicate = this.panelAddGeofencesService.$isDuplicate;
    }

    ngOnInit(): void {
      if(!environment.production) console.log("ngOnInit polygon-selector");
      
      this.createPolygonPoints(false);
    }

    ngOnDestroy(): void {
      if(!environment.production) console.log("ngOnDestroy polygon-selector");
      
      this.polygonDrawToolService.removeGeofencePolygonDrawControl();
      this.isPolygonButtonMsgVisible = false;
      this.isPolygonEditButtonMsgVisible = false;
      this.AddPolygonSelected = "";
      this.mapHelperService.UpdateLayerGeoJson("PolygonActiveSource",this.mapHelperService.Empty_GeoJson);
      this.polygonDrawToolService.polygonPoints = [];
    }
  
    createPolygonPoints(isFromButton: boolean){

      if(!this.polygonDrawToolService.drawGeofencePolygon || typeof this.polygonDrawToolService.drawGeofencePolygon.getAll !== 'function'){
        this.polygonDrawToolService.addGeofencePolygonDrawControl();
      }
      var featuresLength = 0;
      try{
        featuresLength = this.polygonDrawToolService.drawGeofencePolygon.getAll().features.length;
      }catch(error){
        this.polygonDrawToolService.addGeofencePolygonDrawControl();
        featuresLength = this.polygonDrawToolService.drawGeofencePolygon.getAll().features.length;
      }
      //checa si ya hay un poligono dibujado, si no, permite crear uno nuevo
      if (featuresLength < 1) {
        this.isPolygonButtonMsgVisible = true;
        //checa si el poligono se está editando, si sí, eliminar el poligono y permitir crear uno nuevo
        //si está creando uno nuevo, no permite crear otro hasta que se elimine el que ya está creado
        if (this.$guidEditable != "") {
          if(!environment.production) console.log("editando poligono si guid", this.polygonDrawToolService.drawGeofencePolygon.getAll().features, this.$guidEditable);
          this.polygonDrawToolService.drawGeofencePolygon.deleteAll();
          this.polygonDrawToolService.drawGeofencePolygon.changeMode('draw_polygon');
          this.AddPolygonSelected = "create";
        }else{
          if(!environment.production) console.log("editando poligono no guid", this.polygonDrawToolService.drawGeofencePolygon.getAll().features, this.$guidEditable);
          this.polygonDrawToolService.drawGeofencePolygon.changeMode('draw_polygon');
          this.AddPolygonSelected = "create";
        }
      }
      else{
        if(!environment.production) console.log("editando poligono", this.polygonDrawToolService.drawGeofencePolygon.getAll().features, this.polygonDrawToolService.drawGeofencePolygon.getAll());
        if(isFromButton)
          this.notificationToastService.showError("Ya se ha creado un polígono","Error al Crear Polígono");
      }
    }

    editPolygonPoints(){
    //checa si ya hay un poligono dibujado, si no, manda mensaje de error, si sí, permite editar los vertices
    if (this.polygonDrawToolService.drawGeofencePolygon.getAll().features != null && this.polygonDrawToolService.drawGeofencePolygon.getAll().features.length > 0) {
      const lastFeatureId = this.polygonDrawToolService.drawGeofencePolygon.getAll().features[0] != null ? this.polygonDrawToolService.drawGeofencePolygon.getAll().features[0].id.toString() : null; 
      this.polygonDrawToolService.drawGeofencePolygon.changeMode('direct_select' , { featureId: lastFeatureId });
      this.isPolygonEditButtonMsgVisible = true;
      this.AddPolygonSelected = "edit";
      this.fullScreen = false;
    }else{
      this.notificationToastService.showError("No se ha creado un polígono","Error al Editar Polígono");
    }
  }

  //boton de eliminar vertices
  deletePolygonPoints(){
      this.polygonDrawToolService.drawGeofencePolygon.deleteAll();
      this.polygonDrawToolService.updatePolygonArea('draw.delete');
      this.AddPolygonSelected = "";
  }

  onVisibilityChange(isVisible: boolean) {
    this.isPolygonButtonMsgVisible = isVisible;
    this.isPolygonEditButtonMsgVisible = isVisible;
  }
}
